// @ts-nocheck
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
// import useGetGlLedgersList from '@hooks/Finance/useGetGlLedgersList';
import useLookupCurrency from '@hooks/Lookups/use-Lookup-Currency';

export const SelectCurrencies = ({ value, onChange }) => {
  const { t, i18n } = useTranslation();
  const { loading, error, CurrencyOptions } = useLookupCurrency();

  return (
    <Select
      classNamePrefix='react-select'
      isLoading={loading}
      isSearchable={true}
      isClearable
      options={CurrencyOptions}
      value={CurrencyOptions?.find(f => f.value === value)}
      onChange={onChange}
      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
    />
  );
};
